import {
  Search, PenLine, LayoutGrid, Clapperboard, Users, ListOrdered, Image,
  Mic, Music, AudioLines, Film, ShieldCheck, Cpu, Share2, Sparkles,
} from "lucide-react";

export const AGENT_ICONS = {
  Search, PenLine, LayoutGrid, Clapperboard, Users, ListOrdered, Image,
  Mic, Music, AudioLines, Film, ShieldCheck, Cpu, Share2, Sparkles,
};

export const iconFor = (name) => AGENT_ICONS[name] || Sparkles;
